import React from 'react'
import SelectInput from './SelectInput'
import {
  useSelector
} from 'react-redux'

const SelectRecuperation = (props) => {
  const settings = useSelector(state => state.settings.variables)
  return (
    <SelectInput
      label="Récupération"
      options={settings.heure.recuperation.map((item, index) => {
        return {
          value: index,
          label: item
        }
      })}
      {...props}
    />
  )
}

export default SelectRecuperation
